import React from 'react';
import { useTranslation } from 'react-i18next';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  itemName,
  isLoading = false 
}) => {
  const { t } = useTranslation('organizers');

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <div className="modal-content" role="dialog" aria-modal="true">
        {/* Modal Header */}
        <div className="modal-header">
          {/* <div className="modal-icon">
            <img src="/alert-triangle.svg" alt={t('warning')} className="warning-icon" />
          </div> */}
          <h3 className="modal-title">
            {title || t('deleteConfirmationTitle')}
          </h3>
          <button
            onClick={onClose}
            className="modal-close-btn"
            aria-label={t('close')}
            disabled={isLoading}
          >
            <img src="/x.svg" alt={t('close')} className="close-icon" />
          </button>
        </div>

        {/* Modal Body */}
        <div className="modal-body">
          <p className="modal-message">
            {message || t('deleteConfirmationMessage')}
          </p>
          {itemName && (
            <div className="item-highlight">
              <strong>{itemName}</strong>
            </div>
          )}
          <p className="modal-warning">
            {t('deleteWarning')}
          </p>
        </div>

        {/* Modal Footer */}
        <div className="modal-footer">
          <button
            onClick={onClose}
            className="btn btn-cancel"
            disabled={isLoading}
          >
            {t('cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="btn btn-delete"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading-content">
                <img src="/loader.svg" alt={t('loading')} className="spinner" />
                {t('deleting')}
              </span>
            ) : (
              <>
                <img src="/trash.svg" alt={t('delete')} className="delete-icon" />
                {t('delete')}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;